<div class="modal-header text-center">
    <h4 class="modal-title display-inline-block ">{{getHeader(nextAchievements.length)}}</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>    
</div>

@if(current) {
<div class="modal-body">    

    <ngx-particles
        [id]="tsparticlesId"
        [options]="particlesOptions"
        (particlesLoaded)="particlesLoaded($event)"
    ></ngx-particles>
    @if(currentTrophy){
        <div class="text-center">    
            <div><h4>{{getTrophyTitle(currentTrophy)}}</h4></div>
            <div>
                <app-superelf-trophy-icon size="10x" [leagueName]="nameService.convertToLeagueName(currentTrophy.getCompetition())"></app-superelf-trophy-icon>
            </div>
            <div><h2 class="fw-bold">{{currentTrophy.poolUser.user.name}}</h2></div>
        </div>
    }
    @if(currentBadge){
        <div class="text-center">    
            <div><h4>{{currentBadge.poolName}} {{currentBadge.seasonShortName}}</h4></div>
            <div><h4>{{nameService.getBadgeCategoryName(currentBadge.getCategory())}}-badge</h4></div>
            <div>
                <app-superelf-badge-icon size="5x" [badgeCategory]="currentBadge.getCategory()"></app-superelf-badge-icon>
            </div>
            <div><h2 class="fw-bold">{{currentBadge.poolUser.user.name}}</h2></div>
        </div>
    }    
</div>
}
<div class="modal-footer d-flex justify-content-around border-top-0">
    <button type="button" class="btn btn-secondary" [attr.disabled]="previousAchievements.length === 0 ? true : null" (click)="previous()">vorige</button>
    @if(nextAchievements.length > 0) {
        <button type="button" class="btn btn-secondary" (click)="next()">volgende</button>
    }
    @else {
        <button type="button" class="btn btn-secondary" (click)="goToAchievements()">
            <app-superelf-icon [icon]=facTrophy></app-superelf-icon>
            <span class="ms-1">naar prijzenkast</span>
        </button>
    }
</div>

